var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22769_8927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4933 28.64L53.8933 24.4267C53.2267 23.6267 52.6667 22.1333 52.6667 21.0667V16.5333C52.6667 13.7067 50.3467 11.3867 47.52 11.3867H42.9867C41.92 11.3867 40.4 10.8267 39.6 10.16L35.3867 6.56C33.5467 4.98667 30.5333 4.98667 28.6933 6.56L24.4267 10.16C23.6267 10.8267 22.1333 11.3867 21.0667 11.3867H16.4533C13.6267 11.3867 11.3067 13.7067 11.3067 16.5333V21.0667C11.3067 22.1067 10.7733 23.6 10.1067 24.4L6.50668 28.64C4.96001 30.5067 4.96001 33.4933 6.50668 35.3067L10.1067 39.5467C10.7733 40.32 11.3067 41.84 11.3067 42.88V47.44C11.3067 50.2667 13.6267 52.5867 16.4533 52.5867H21.0933C22.1333 52.5867 23.6533 53.1467 24.4533 53.8133L28.6667 57.4133C30.5067 58.9867 33.52 58.9867 35.36 57.4133L39.5733 53.8133C40.3733 53.1467 41.8667 52.5867 42.9333 52.5867H47.4667C50.2933 52.5867 52.6133 50.2667 52.6133 47.44V42.9067C52.6133 41.84 53.1734 40.3467 53.84 39.5467L57.44 35.3333C59.0667 33.52 59.0667 30.5067 57.4933 28.64ZM30 21.68C30 20.5867 30.9067 19.68 32 19.68C33.0933 19.68 34 20.5867 34 21.68V34.56C34 35.6533 33.0933 36.56 32 36.56C30.9067 36.56 30 35.6533 30 34.56V21.68ZM32 44.9867C30.5333 44.9867 29.3333 43.7867 29.3333 42.32C29.3333 40.8533 30.5067 39.6533 32 39.6533C33.4667 39.6533 34.6667 40.8533 34.6667 42.32C34.6667 43.7867 33.4933 44.9867 32 44.9867Z",
    fill: "#98134D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22769_8927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhcAlert);
export default __webpack_public_path__ + "static/media/ahc-alert.1f21e699514bb7285eda2e9d4924a8fd.svg";
export { ForwardRef as ReactComponent };